export default __webpack_public_path__ + "static/media/69_mobile.005a81ce.jpg";